import InputBase from "../../../appl/view/components/inputFields/InputBase";
import PropType from "prop-types";
import GF from "../../utils/GF";
import PropTypes from "prop-types";
import {FormControlLabel, Checkbox as MuiCheckbox} from "@mui/material";

class Checkbox extends InputBase {

  constructor(props) {
    super(props);
    this.state.checked = GF.getValue(this.props.checked, (this.props.type === 'checkboxWithNoneState' ? null : false));
    this.state.readonly = GF.getValue(this.props.readonly, false);
  }

  onChange(e) {
    this.fireOnChange(e, this.state.checked);
  }

  onClick() {
    switch (this.state.checked) {
      case null:
        this.state.checked = true;
        break;
      case false:
        if (this.props.type === 'checkboxWithNoneState') {
          this.state.checked = null;
        } else {
          this.state.checked = true;
        }
        break;
      case true:
        this.state.checked = false;
        break;
    }
    this.setState(this.state);
  }

  buildInputFav() {
    return <input ref={this.inputElementRef} type="checkbox" className="appearance-none content-star checked:content-star-fill"/>;
  }

  buildInputCheckBox() {
    // Bei type='checkboxWithNoneState' gibt es 3 Zustände, die sich der Reihe nach
    // durchklicken lassen: true (Wert 1 wird gesucht) -> false (Wert 0 wird gesucht,
    // leere Checkbox) -> null (Feld wird nicht für die Suche verwendet, dargestellt
    // als indeterminate/Minus-Symbol). Das Minus erscheint damit erst als letzter
    // Zustand im Klick-Zyklus.
    const isNoneStateType = this.props.type === 'checkboxWithNoneState';
    return <FormControlLabel
      label={this.props.labelElement}
      control={<MuiCheckbox
        ref={this.inputElementRef}
        onClick={(e) => this.onClick(e)}
        onChange={(e) => this.onChange(e)}
        disabled={this.props.disabled}
        checked={this.state.checked === true}
        indeterminate={isNoneStateType && this.state.checked !== true && this.state.checked !== false}
        sx={this.props.sx}/>}/>
  }

  getValue() {
    return this.state.checked;
  }

  setValue(checked) {
    this.state.checked = checked;
    this.setState(this.state);
  }

  setReadonly(readonly) {
    this.state.readonly = readonly;
    this.setState(this.state);
  }

  setFocus() {
    if (GF.checkNotNull(this.inputElementRef.current)) {
      this.inputElementRef.current.focus();
    }
  }

  render() {
    if (this.props.type === 'fav') {
      return this.buildInputFav();
    } else {
      return this.buildInputCheckBox();
    }
  }
}

Checkbox.propTypes = {
  type: PropType.oneOf(['checkbox', 'checkboxWithNoneState', 'fav']),
  labelElement: PropTypes.any,
  onChange: PropType.func,
  checked: PropType.bool,
  inputLayout: PropTypes.oneOf(['inline', 'outline', '']),
  readonly: PropType.bool,
  disabled: PropType.bool,
  sx: PropTypes.object,
}

export default Checkbox;